import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import imgCookie from './images/howto_cookie.jpg';
import imgHeader from './images/howto_header.jpg';
import imgKauf from './images/howto_kauf.jpg';
import imgPreise from './images/howto_preise.jpg';
import imgZahlart from './images/howto_zahlart.jpg';
import imgZurkasse from './images/howto_zurkasse.jpg';

interface HowToStartState extends BasePageState {}
interface HowToStartModel {}

export default class HowToStartPage extends Basepage<
  HowToStartState,
  HowToStartModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="HowToStart">
        <b>Der Buchbutler - wie geht es los?</b>
        <br />
        <br />
        Nach dem Aufrufen der Seite www.buchbutler.de wird Ihnen unten auf der
        Seite ein Cookie Banner angezeigt mit der Auswahl der passenden Shop
        Einstellung.
        <br />
        <br />
        <img src={imgCookie} />
        <br />
        <br />
        <br />
        <li>
          <b>1.</b> klicken Sie im Cookie Banner auf BUCHHÄNDLER
          <br />
          .. wenn das erfolgt ist steht oben über der suche in rot: Barsortiment
          on demand für Buchhändler
          <br />
          <br />
          <img src={imgHeader} />
          <br />
          <br />
          .. wenn dort irgendwas anderes steht, klicken Sie hinter dem roten
          Text in der obersten Zeile über der Suche bitte auf den Stern und
          wählen dann im Cookie Banner unten den Punkt BUCHHÄNDLER aus
          <br />
          <br />
        </li>
        <li>
          <b>2.</b> Sie sehen nun an jedem Artikel Ihren Einkaufspreis und Ihren
          Rabatt.
          <br />
          Außerdem sehen Sie die Lieferzeit des Artikels.
          <br />
          <br />
          <img src={imgPreise} />
          <br />
          <br />
          der Buchbutler ist ein Barsortiment on Demand und hat daher kaum
          Artikel direkt am Lager, dh. die Artikel werden vom Buchbutler für Sie
          besorgt und dann an Sie oder Ihren Kunden versenden.
          <br />
          <br />
        </li>
        <li>
          <b>3.</b> legen Sie den Artikel einfach in Ihren Warenkorb und
          wiederholen Sie den Vorgang so oft Sie wollen :-)
          <br />
          <br />
        </li>
        <li>
          <b>4.</b> wenn Ihr Warenkorb gefüllt ist klicken Sie auf den Button{' '}
          <b>ZUR KASSE</b>
          <br />
          <br />
          <img src={imgZurkasse} />
          <br />
          <br />
        </li>
        <li>
          <b>5.</b> Sie werden nun durch den Registrierungsprozess geführt
          <br />
          <br />
        </li>
        <li>
          <b>6.</b> haben Sie keine Verkehrsnummer, dann melden Sie sich bitte
          einmal bei unserem Kundenservice unter{' '}
          <a href="tel:+4925718072880">02571/8 07 28 80</a>
          <br />
          <br />
        </li>
        <li>
          <b>7.</b> es erscheint nach erfolgreichem Ausfüllen aller Felder die
          Auswahl der Zahlungsart
          <br />
          <br />
          <img src={imgZahlart} />
          <br />
          <br />
        </li>
        <li>
          <b>8.</b> wählen Sie nun noch Ihre Zahlart aus (Rechnung, BAG, etc)
          <br />
          <br />
        </li>
        <li>
          <b>9.</b> ganz unten auf der Seite erscheint dann nochmals: KAUF
          abschließen
          <br />
          <br />
          <img src={imgKauf} />
          <br />
          <br />
        </li>
        <li>
          <b>10.</b> Bitte klicken Sie dann auf den Button{' '}
          <b>KAUF abschließen</b>
          <br />
          <br />
        </li>
      </div>
    );
  }
  initState(base: BasePageState): HowToStartState {
    let newState: HowToStartState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'HowToStart';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Seite Buchbutler - wie gehts los?</span>;
  }
  getType(): string {
    return 'HowToStartPage';
  }
}
